import React from "react";
import SubApp from "../SubApp";
import { useDispatch } from "react-redux";
import { useSelectedSystems } from "../../hooks/useCloudSelectors";
import { Box, Grid, IconButton, Typography, useMediaQuery, useTheme } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { setSelectedSystems } from "../../ducks/customersDuck";

const DashboardsList = ({ showSidebar }) => {
  const list = useSelectedSystems();
  const dashboardCount = list.length;
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  // Floor so a card never fully collapses. Otherwise each card fills the view height
  // (height:100% below) and its own content scrolls internally. When several cards are
  // stacked, the outer Box's overflowY:"auto" scrolls between them.
  const dashBoardMinHeight = "420px";

  const removeSystemFromSelections = (e, item) => {
    console.log("removeSystemFromSelections", item);
    const selectedDeviceItem = {
      ...item,
      customerId: item.customerId,
      customerName: item.customerName,
    };
    const id = item.deviceId;
    const isRemoving = list.find((o) => o.deviceId === id);
    const selected = isRemoving && list.filter((dev) => dev.deviceId !== id);
    const devices = isRemoving ? selected : [...list, selectedDeviceItem];

    dispatch(setSelectedSystems({ devices, path: "devices" }));
    localStorage.setItem("selectedSystems", JSON.stringify(devices));
  };

  return (
    <Box
      sx={{
        height: "100%",
        overflowY: "auto",
        padding: "6px",
        background: theme.palette.background.default,
        // backdropFilter: "blur(8px)",
        borderRadius: 1,
      }}
    >
      <Grid container spacing={2} sx={{ height: "100%" }}>
        {list?.length > 0 &&
          list.map((item) => (
            <Grid
              key={item.deviceId}
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: dashboardCount > 1 ? 6 : 12 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                minHeight: dashBoardMinHeight,
                ...(dashboardCount >= 2 && { fontSize: "12px" }),
                "@keyframes fade-in": { "0%": { opacity: 0 }, "100%": { opacity: 1 } },
                animation: "fade-in 0.2s ease-in",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexShrink: 0,
                  // border: `1px solid ${theme.palette.dashboard.border}`,
                  // borderBottom: "none",
                }}
              >
                <Typography variant="h6" sx={{ textAlign: "center" }}>
                  {`${item.customerName} - ${item.deviceName}`}
                </Typography>
                <IconButton onClick={(e) => removeSystemFromSelections(e, item)} sx={{ ml: 1 }}>
                  <ClearIcon fontSize="large" color="disabled" />
                </IconButton>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  minHeight: 0,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <SubApp dashboardItem={item} dashboardCount={dashboardCount} />
              </Box>
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};


export default DashboardsList;
